import React from "react";
import "./partner.css";
import awsIcon from "../../images/PartnerSection/amazon-icon.png";
import cisco from "../../images/PartnerSection/cisco-icon.png";
import atTIcon from "../../images/PartnerSection/at-and-t-icon.png";
import dellIcon from "../../images/PartnerSection/dell-icon.png";
import comcastIcon from "../../images/PartnerSection/comcast-icon.png";
import verizonIcon from "../../images/PartnerSection/verizon-icon.png";

export default function Partners() {
  return (
    <section className={`agent-rai-trusted-partners`}>
      <div className="container">
        <div className="trusted-by-partners-wrapper">
          <h2>Build Trust and Transparency with Industry-Leading Partners</h2>
          <div className="row partner-logo-images">
            <img src={awsIcon} alt="Amazon Logo" />
            <img src={cisco} alt="Cisco Logo" />
            <img src={atTIcon} alt="At and T Logo" />
            <img src={dellIcon} alt="Dell Logo" />
            <img src={comcastIcon} alt="Comcast Logo" />
            <img src={verizonIcon} alt="Verizon Logo" />
          </div>
        </div>
      </div>
    </section>
  );
}
